<template>
    <div>
        <h1 v-show="!isDashboard">{{headingDecision}}</h1>

        <div v-show="!isDashboard" class="mb-3">
            <button class="btn btn-outline-secondary float-right" data-toggle="modal" :data-target="'#modal-' + routeName">
                <i class="fas fa-info-circle"></i> more information
            </button>
        </div>
        <h3>{{heading}}</h3>
    </div>
</template>

<script>
    import {mapMutations, mapState} from 'vuex';
    export default {
        name: "RouteHeader",

        data() {
          return {
              local: {
                  matrix: {}
              }
          }
        },
        computed: {

            heading() {
                return this.$route.meta.header
            },

            headingDecision() {
                return this.$store.state.data.matrix.name
            },
            isDashboard() {
                if(this.$route.name == 'dashboard') {
                    return true
                }
                return false
            },
            routeName() {
                return this.$route.name
            }
        },

    }
</script>

<style scoped>

</style>